module.exports = __webpack_public_path__ + "static/media/YM51_2.7ac3e8ba.jpg";